import { render, staticRenderFns } from "./table63.vue?vue&type=template&id=816e4b8c&scoped=true&"
import script from "./table63.vue?vue&type=script&lang=js&"
export * from "./table63.vue?vue&type=script&lang=js&"
import style0 from "./table63.vue?vue&type=style&index=0&id=816e4b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816e4b8c",
  null
  
)

export default component.exports